import { WorkflowStepsBaseService } from "app/core/workflow/workflow-steps/workflow-steps-base.service";
import { ConfirmNewPremiumComponentPath } from "app/core/workflow/page-path/statement-page-path/confirm-new-premium-price.path";

export class WorkflowConfirmNewPremiumPriceService extends WorkflowStepsBaseService {
  public get skipWorkflowMechanisms(): boolean {
    return true;
  }

  public get isRequired(): boolean {
    return (
      !!this.statement &&
      !!this.statement.request_new_price_acceptance &&
      !this.statement.isForClientApproval &&
      !this.isBusiness &&
      !this.isTaxAdviser
    );
  }

  public get checkCanGo(): boolean {
    return this.isRequired;
  }

  public get urlRegex(): RegExp {
    return ConfirmNewPremiumComponentPath.regex();
  }

  public get url(): string {
    return ConfirmNewPremiumComponentPath.url(this.getStatementId);
  }
}
